import React from "react";
import SVGIcon, { IconProps } from "ui/SVGIcon";

const path =
  "M10.0001 1.66666C5.40008 1.66666 1.66675 5.39999 1.66675 9.99999C1.66675 14.6 5.40008 18.3333 10.0001 18.3333C14.6001 18.3333 18.3334 14.6 18.3334 9.99999C18.3334 5.39999 14.6001 1.66666 10.0001 1.66666ZM10.0001 4.16666C11.3834 4.16666 12.5001 5.28332 12.5001 6.66666C12.5001 8.04999 11.3834 9.16666 10.0001 9.16666C8.61675 9.16666 7.50008 8.04999 7.50008 6.66666C7.50008 5.28332 8.61675 4.16666 10.0001 4.16666ZM5.00008 13.3167C6.07508 14.9333 7.91675 16 10.0001 16C12.0834 16 13.9251 14.9333 15.0001 13.3167C14.9751 11.6583 11.6584 10.75 10.0001 10.75C8.33341 10.75 5.02508 11.6583 5.00008 13.3167Z";

export default function TeacherAccount(props: IconProps) {
  return (
    <SVGIcon
      path={path}
      viewBox="0 0 20 20"
      fillRule="evenodd"
      clipRule="evenodd"
      {...props}
    />
  );
}
